import { render } from "./EditClientHousehold.vue?vue&type=template&id=44e2107c"
import script from "./EditClientHousehold.vue?vue&type=script&lang=js"
export * from "./EditClientHousehold.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__